import { render } from "./EditPlantJournalHeader.vue?vue&type=template&id=6371957a"
import script from "./EditPlantJournalHeader.vue?vue&type=script&lang=js"
export * from "./EditPlantJournalHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__